export default "__VITE_ASSET__BHq_HOxp__"